if (!customElements.get('tp-pv-trilho')) {
  class TpPvTrilho extends HTMLElement {
    connectedCallback() {
      this.trilho = this.querySelector('[data-trilho]');
      if (!this.trilho) return;
      this.atualizar = this.atualizar.bind(this);
      this.querySelectorAll('[data-seta]').forEach((botao) => {
        botao.addEventListener('click', () => {
          const passo = this.trilho.clientWidth * 0.8 * Number(botao.dataset.seta);
          this.trilho.scrollBy({ left: passo, behavior: 'smooth' });
        });
      });
      this.trilho.addEventListener('scroll', this.atualizar, { passive: true });
      window.addEventListener('resize', this.atualizar);
      const atual = this.trilho.querySelector('[aria-current="page"]');
      if (atual) {
        const t = this.trilho.getBoundingClientRect();
        const a = atual.getBoundingClientRect();
        if (a.right > t.right) this.trilho.scrollLeft += a.left - t.left - 8;
      }
      this.atualizar();
      this.querySelectorAll('.tp-pv-tile img').forEach((img) => {
        if (img.complete && img.naturalWidth) this.colorir(img);
        else img.addEventListener('load', () => this.colorir(img), { once: true });
      });
    }

    colorir(img) {
      const lado = 32;
      const canvas = document.createElement('canvas');
      canvas.width = lado;
      canvas.height = lado;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      let dados;
      try {
        ctx.drawImage(img, 0, 0, lado, lado);
        dados = ctx.getImageData(0, 0, lado, lado).data;
      } catch (erro) {
        console.warn('tp-pv-trilho: cor do sabor indisponível', erro);
        return;
      }
      const baldes = new Map();
      for (let i = 0; i < dados.length; i += 4) {
        const [h, s, l] = TpPvTrilho.hsl(dados[i], dados[i + 1], dados[i + 2]);
        if (s < 0.2 || l < 0.1 || l > 0.9 || (h >= 180 && h <= 215)) continue;
        const chave = Math.round(h / 15) % 24;
        baldes.set(chave, (baldes.get(chave) || 0) + s);
      }
      const maior = [...baldes.entries()].sort((a, b) => b[1] - a[1])[0];
      if (!maior) return;
      const tile = img.closest('.tp-pv-tile');
      tile.style.setProperty('--tp-pv-cor', `hsl(${maior[0] * 15} 70% 45%)`);
    }

    static hsl(r, g, b) {
      const [rr, gg, bb] = [r / 255, g / 255, b / 255];
      const max = Math.max(rr, gg, bb);
      const min = Math.min(rr, gg, bb);
      const l = (max + min) / 2;
      const d = max - min;
      if (d === 0) return [0, 0, l];
      const s = d / (1 - Math.abs(2 * l - 1));
      let h;
      if (max === rr) h = ((gg - bb) / d) % 6;
      else if (max === gg) h = (bb - rr) / d + 2;
      else h = (rr - gg) / d + 4;
      return [(h * 60 + 360) % 360, s, l];
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.atualizar);
    }

    atualizar() {
      const t = this.trilho;
      const esq = this.querySelector('[data-seta="-1"]');
      const dir = this.querySelector('[data-seta="1"]');
      if (esq) esq.hidden = t.scrollLeft < 4;
      if (dir) dir.hidden = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    }
  }
  customElements.define('tp-pv-trilho', TpPvTrilho);
}
